export const deviceSize = {
    mobile: 768,
    tablet: 992,
    smlaptop: 1111,
    laptop: 1324,
    desktop: 2024,
};